import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { TokenStorage } from 'src/app/util/token.storage';
import { WebConstants } from 'src/app/util/web.constants';
import { CitationService } from "../../../services/citation.service";
import { CitationViewDialogComponent } from './citation-view-dialog/citation-view-dialog.component';

@Component({
  selector: 'app-citation-management',
  templateUrl: './citation-management.component.html',
  styleUrls: ['./citation-management.component.scss']
})
export class CitationManagementComponent implements OnInit {

  public displayedColumns: string[] = [
    'permitId',
    'lpn',
    'citationStatus',
    'carBootTow',
    'fineAmount',
    'citationTime',
    'comment',    
    'systemAutomatedReason',
    'id'
  ];

  public title: string = WebConstants.MENU_NAMES.CITATION_MANAGEMENT;
  public citationList: any[] = [];
  public dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(public citationService: CitationService,public tokenStorage: TokenStorage,public toastrService: ToastrService,public dialog: MatDialog) { }

  ngOnInit(): void {
    this.getAllCitations()
  }

  getAllCitations(): void {
    this.citationService.getAll()
      .pipe(first())
      .subscribe(response => {    
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.citationList = response.data;
          this.dataSource = new MatTableDataSource(this.citationList);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        } else {
          this.toastrService.error(response.value, "Failed To Load Data!")
        }
      });
  }  

  viewCitationDialog(data: any): void{
    const dialogRef = this.dialog.open(CitationViewDialogComponent, {
      data: data,
      disableClose: true
    })
  }

}
